import to_array from 'to_array';
import _find from 'lodash/find';
import GlobalAlerts from './GlobalAlerts';


const Lang = require('lang');

/**
 * Validar o arquivo adicioanado na
 * importação de despesas
 */
exports.init = function validateFileImportExpense() {
  const formImport = document.querySelector('#formImportExpenses');
  const buttonFormSubmit = document.querySelector('#submitFormImportExpenses');

  if (!document.body.contains(formImport)) {
    return;
  }

  nifty.body.overlay({
    fixed: true
  });

  addListenerForm(formImport, buttonFormSubmit);
}

function addListenerForm(form, buttonFormSubmit) {
  buttonFormSubmit.addEventListener('click', function(event) {
    if ($(form).valid()) {
      if (!hasReceipt(form)) {
        showNeedsReceiptDialog($('#formImportExpenses'));
        return;
      }

      nifty.body.overlay('show');
      form.submit();
    }
  });
}

/**
 * Verificar se existe o recibo
 * @param  {Element} form
 */
const hasReceipt = form => {
  const filePicker = document.querySelector('.importType-file-picker');
  const labels = to_array(form.querySelectorAll('label.importType-file-picker__add'));
  let inputsAreFilled = false;

  if (labels.length) {
    inputsAreFilled = labels
      .map(label => label.querySelector('input[type="file"]'))
      .reduce((hasReceipt, input) => hasReceipt || (!!input && !!input.files.length), false)
  }

  return inputsAreFilled || filePicker.classList.contains('has-file');
};

/**
 * Show messsage de arquivo não exitente
 *
 * @param  {Element} form
 */
const showNeedsReceiptDialog = (form) => {
  bootbox.alert({
    title: Lang.get('js/src/functions/validateFileImportExpense.no_file_title'),
    message: Lang.get('js/src/functions/validateFileImportExpense.no_file_message'),
    closeButton: false,
  }).on('hidden.bs.modal', evt => {
    form.find('.file-picker').first().addClass('file-picker--error');
    form.data('canSend', false);
  });
  form.overlay('hide');
};
